
let currentProduct;
let iframeSrc;
let customer = 'SLOWELIVING';

const waitForMazingFunction = new Promise((resolve) => {
    const interval = 50;
    const checkInterval = setInterval(() => {
        if (typeof mazingProjectAvailable === 'function') {
            clearInterval(checkInterval);
            resolve();
        }
    }, interval);
});

const waitForElement = (selector, timeout = 55000) => {
    return new Promise((resolve) => {
        const interval = 50;
        let elapsedTime = 0;

        const checkInterval = setInterval(() => {
            const element = document.querySelector(selector);
            if (element) {
                clearInterval(checkInterval);
                resolve(element);
            } else if ((elapsedTime += interval) >= timeout) {
                clearInterval(checkInterval);
                resolve();
            }
        }, interval);
    });
};

/////////////////////

const initializeScript = async () => {
    try {
        await waitForMazingFunction;
        console.log('mazingProjectAvailable is now available');
        console.log('Initializing script...');

        // WAIT FOR INSERT ELEMENTS
        const oldImgGalleryContainer = await waitForElement('.product-single__media-slider');

        // GENERATE IFRAME SRC BASED ON CUSTOMER, URL AND INPUT VALUES
        iframeSrc = await mazingProjectAvailable({
            customerName: customer,
            getSKU: () => {
                const url = window.location.href;
                const parts = url.split("/");
                const product = parts.filter(part => part.trim() !== '').pop();
                const productParts = product.split('?');

                currentProduct = `${productParts[0]}`;

                console.log('extracted sku: ' + currentProduct.toLowerCase());

                return currentProduct.toLowerCase();
            }
        });

        // STOP SCRIPT IF NO IFRAME SRC IS FOUND
        if (!iframeSrc) {
            console.log('iframeSrc not found, skipping update.');
            return;
        }

        const newImgGalleryContainer = document.createElement('div');
        newImgGalleryContainer.id = 'Mazing-Product-Gallery';
        newImgGalleryContainer.classList.add('product-media-gallery');
        newImgGalleryContainer.style.display = 'flex';
        newImgGalleryContainer.style.overflow = 'hidden';
        newImgGalleryContainer.style.alignItems = 'center';

        const oldImgGallery = oldImgGalleryContainer.querySelector('.flickity-slider');

        const oldImages = [...oldImgGallery.children];

        const cleanedImages = oldImages.map(img => {
            const clonedImg = img.cloneNode(true);
            clonedImg.style.position = 'static';
            clonedImg.style.transform = 'none';
            clonedImg.style.flexShrink = '0';
            return clonedImg;
        });

        const iframeWrapper = document.createElement('div');
        iframeWrapper.classList.add('product-gallery__media', 'snap-center');
        iframeWrapper.style.overflow = 'hidden';
        iframeWrapper.style.width = '100%';
        iframeWrapper.id = 'mazing-div';
        iframeWrapper.style.position = 'relative';
        iframeWrapper.style.background = '#FAFAFA';
        iframeWrapper.style.display = 'none';
        iframeWrapper.style.flexShrink = '0';

        const updateIframeHeight = () => {
            const referenceImage = newImgGalleryContainer.children[0];

            if (referenceImage) {
                const newHeight = referenceImage.getBoundingClientRect().height;
                iframeWrapper.style.height = `${newHeight}px`;
                console.log('Updated iframeWrapper height:', newHeight);
            }
        };

        window.addEventListener('resize', () => {
            requestAnimationFrame(updateIframeHeight);
        });

        const iframe = document.createElement('iframe');
        iframe.src = iframeSrc;
        iframe.style.border = '0';
        iframe.style.height = '100%';
        iframe.style.width = '100%';
        iframe.setAttribute('allowusermedia', '');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('data-cy', 'cy-mazing-frame');
        iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; camera *; xr-spatial-tracking');

        iframeWrapper.appendChild(iframe);

        cleanedImages.forEach((img, index) => {
            if (index === 1) {
                newImgGalleryContainer.appendChild(iframeWrapper);
            }
            newImgGalleryContainer.appendChild(img);
        });

        oldImgGalleryContainer.replaceWith(newImgGalleryContainer);

        console.log('Image-Gallery replaced!');

        const oldThumbGalleryContainer = await waitForElement('#ProductThumbs');

        if (!oldThumbGalleryContainer) {
            console.log('No Thumb Gallery found; return;')
            return;
        }

        const newThumbGalleryContainer = document.createElement('div');
        newThumbGalleryContainer.id = 'Mazing-Product-Thumbs';
        newThumbGalleryContainer.classList.add('product-thumbnails');
        newThumbGalleryContainer.style.display = 'flex';
        newThumbGalleryContainer.style.overflowX = 'auto';
        newThumbGalleryContainer.style.alignItems = 'center';

        newThumbGalleryContainer.style.scrollbarWidth = 'none'; // Firefox
        newThumbGalleryContainer.style.msOverflowStyle = 'none'; // Internet Explorer & Edge

        // Chrome, Safari, Edge Chromium
        newThumbGalleryContainer.style.cssText += `
            &::-webkit-scrollbar {
                display: none;
            }
        `;

        const oldThumbGallery = oldThumbGalleryContainer.querySelector('.flickity-slider');
        if (!oldThumbGallery) {
            return;
        }

        const oldThumbnails = [...oldThumbGallery.children];

        if (oldThumbnails.length === 0) {
            return;
        }

        const cleanedThumbnails = oldThumbnails.map(thumb => {
            const clonedThumb = thumb.cloneNode(true);
            clonedThumb.style.position = 'static';
            clonedThumb.style.transform = 'none';
            clonedThumb.style.flexShrink = '0';
            return clonedThumb;
        });

        const firstThumb = cleanedThumbnails[0];
        const mazingThumb = document.createElement('div');
        mazingThumb.classList.add('product-single__thumbnail');
        mazingThumb.id = 'mazing-thumb';

        const thumbStyles = getComputedStyle(firstThumb);
        const thumbWidth = thumbStyles.width !== 'auto' ? thumbStyles.width : '80px';
        const thumbHeight = thumbStyles.height !== 'auto' ? thumbStyles.height : '80px';

        mazingThumb.style.width = thumbWidth;
        mazingThumb.style.height = thumbHeight;
        mazingThumb.style.display = 'flex';
        mazingThumb.style.alignItems = 'center';
        mazingThumb.style.justifyContent = 'center';
        mazingThumb.style.flexShrink = '0';

        const mazingA = document.createElement('a');
        mazingA.classList.add('product-single__thumbnail-link')

        const thumbImg = document.createElement('img');
        thumbImg.src = 'https://cdn.mazing.link/assets/svg/3D.svg';
        thumbImg.style.display = 'block';
        thumbImg.style.width = '100%';
        thumbImg.style.height = '100%';
        thumbImg.style.objectFit = 'contain';
        thumbImg.style.padding = '25%';
        thumbImg.style.filter = 'brightness(0) saturate(100%) invert(27%) sepia(12%) saturate(21%) hue-rotate(5deg) brightness(89%) contrast(84%)';
        //thumbImg.style.background = '#F9F6F1';

        mazingA.appendChild(thumbImg);
        mazingThumb.appendChild(mazingA);

        cleanedThumbnails.forEach((thumb, index) => {
            if (index === 1) {
                newThumbGalleryContainer.appendChild(mazingThumb);
            }
            newThumbGalleryContainer.appendChild(thumb);
        });

        oldThumbGalleryContainer.replaceWith(newThumbGalleryContainer);

        console.log('Thumbnail-Gallery replaced!');

        mazingThumb.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            iframeWrapper.style.display = 'block';
        });

        const allThumbs = newThumbGalleryContainer.querySelectorAll('.product-single__thumbnail');
        const allImages = newImgGalleryContainer.children;

        allThumbs.forEach((thumb, index) => {

            thumb.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();

                allThumbs.forEach(t => t.classList.remove('is-selected', 'is-nav-selected'));

                thumb.classList.add('is-selected', 'is-nav-selected');

                const targetImage = allImages[index];

                if (targetImage) {
                    newImgGalleryContainer.scrollTo({
                        left: targetImage.offsetLeft,
                        behavior: 'smooth'
                    });
                }
            });
        });


        updateIframeHeight();


        // POST MESSAGE SECTION

        const fieldset = document.querySelector('fieldset');
        const variants = fieldset.querySelector('.radio__buttons');

        if (fieldset) {
            console.log('Variants found.');

            Array.from(variants.children).forEach((variant, variantIndex) => {
                variant.addEventListener('click', () => {
                    const input = variant.querySelector('input');

                    const allImages = Array.from(newImgGalleryContainer.children).filter(child => child !== iframeWrapper);
                    const allThumbs = Array.from(newThumbGalleryContainer.children).filter(child => child !== mazingThumb);
                    const allXThumbs = Array.from(newThumbGalleryContainer.children);

                    const targetImage = allImages[variantIndex];

                    if (targetImage) {
                        newImgGalleryContainer.scrollTo({
                            left: targetImage.offsetLeft,
                            behavior: 'smooth'
                        });
                    }

                    allXThumbs.forEach(thumb => thumb.classList.remove('is-selected', 'is-nav-selected'));

                    const targetThumb = allThumbs[variantIndex];
                    if (targetThumb) {
                        targetThumb.classList.add('is-selected', 'is-nav-selected');
                    }

                    // iframe.contentWindow.postMessage({
                    //     type: 'SWITCH_VARIANT',
                    //     value: {
                    //         trigger: input.value.toLowerCase().trim().replace(/\s+/g, '-')
                    //     }
                    // }, '*');
                })
            })
        }

        console.log('Mazing script initialized.')

    } catch (error) {
        console.error('Initialization failed:', error);
    }
};

initializeScript();